import { render, staticRenderFns } from "./CadastroObitoLegado.vue?vue&type=template&id=3051bff4&"
import script from "./CadastroObitoLegado.vue?vue&type=script&lang=js&"
export * from "./CadastroObitoLegado.vue?vue&type=script&lang=js&"
import style0 from "./CadastroObitoLegado.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports